import { render, staticRenderFns } from "./ChecklistEnvironmentEvidenceFile.vue?vue&type=template&id=c4cb0928&"
import script from "./ChecklistEnvironmentEvidenceFile.vue?vue&type=script&lang=js&"
export * from "./ChecklistEnvironmentEvidenceFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports